import { isAfter, parse } from 'date-fns';
import { globalColors, XMRColors } from 'globalStyle';
export const getColor = (value: number) => {
  if (value >= 0 && value <= 50) {
    return XMRColors.red;
  }
  if (value > 50 && value <= 75) {
    return XMRColors.yellow;
  } else {
    return XMRColors.green;
  }
};
export const getMaxValue = data => {
  let maxValue = -Infinity;
  data.forEach(record => {
    const avg = record.avg;
    const xValue = record.x.value;
    const minMax = Math.max(...record.minMax);
    const currentMaxValue = Math.max(maxValue, avg, xValue, minMax);
    maxValue = currentMaxValue > maxValue ? currentMaxValue : maxValue;
  });
  return maxValue;
};
//* Add to data gray zone based on currentShiftStartTime
export const addGrayZone = (data, currentShiftStartTime, maxValue) => {
  const timeLimit = new Date(currentShiftStartTime);
  const result = data.map((record, index) => {
    if (isAfter(record.time, timeLimit)) {
      return { ...record, grayZone: [0, 0] }; // add gray zone with : [0, 0]
    } else {
      return { ...record, grayZone: [0, maxValue] }; // add gray zone with :  [0, maxValue]
    }
  });
  return result;
};
export const convertServerResponseToChartData = data => {
  return data.map(record => {
    return {
      time: new Date(record.intervalStart),

      avg: record.xAvg ?? 0,
      x: {
        value: record.x ?? 0,
        isPurple: !!record.xRule1,
      },
      minMax: [record.xMin ?? 0, record.xMax ?? 0],
      timeSpan: record.timeSpan ?? 0,
      currentImpression: record.currentImpression ?? 0,
      currentImpressionPerformance: record.currentImpressionPerformance ?? 0,
      imageName: record.imageName ?? '',
      imageCopiesPrinted: record.imageCopiesPrinted ?? 0,
      imagePrintingPerformance: record.imagePrintingPerformance ?? 0,
    };
  });
};
export const getFirstSystem = ({ filterData, selectedSystemGroup }) => {
  const firstSite = filterData[selectedSystemGroup].sites[0];
  const firstSiteSystems = filterData[selectedSystemGroup].systems
    .filter(system => system.siteId === firstSite.id)
    .sort((a, b) => a.name.localeCompare(b.name));
  return firstSiteSystems[0];
};
